<template>
	<Page :info="info"/>
</template>
<script>
import Page from '../common/Page'
export default {
	components:{Page},
	data(){
		return {
			info:{
				banner:{
					img:'/static/images/scheme/banner7.jpg',
					title:'电子行业风险解决方案',
					subtitle:'我们针对于电子行业特性，输出定制如下组合方案， <br>供电子行业基于企业需求进行投保'
				},
				product:[0,1,7,6,4,5],
				case:[0,1,6,4,5]
			}
		}
	},
}
</script>


// WEBPACK FOOTER //
// src/pages/scheme/components/page/Dianzi.vue